import React, { Component, createRef, useEffect, useState } from "react";
import './AssessmentList.scss';
import '../../../shared/scss/theme.scss';
import { postApi, putApi, getApi } from "../../../shared/services/apiHelper";
import { programmeList, departmentList, assessmentCycleList, departmentUpdate, departmentAdd, } from "../../../shared/settings/apiConfig";
import { Button, Form, InputGroup, Modal, Spinner } from "react-bootstrap";
import { Datatable } from "../../../shared/datatable/Datatable";
import InputGroupText from "react-bootstrap/esm/InputGroupText";
import { Validators } from "../../../shared/utils/Validators";
import { SelectInput, TextInput } from "../../../shared/form/FormInput";

const AssessmentGrade = (props) => {
    const dataTable = createRef();
    const conditions = [
        { id: 1, option: "Last Assessment Mark" },
        { id: 2, option: "Cummulative Average" },
        { id: 3, option: "Last 3 Average" }
      ];
      const rules = [
        { id: 1, option: "Greater Than" },
        { id: 2, option: "Less Than" },
        { id: 3, option: "Equal To" },
        { id: 4, option: "Greater Than or Equal To" },
        { id: 5, option: "Less Than or Equal To" },
        { id: 6, option: "Not Less Than" }
      ];
    const gradData = [
        {
            id: 1,
            department: 'COMMERCE',
            programme: 'B.Sc  - Mathematics',
            subject: 'Integral Calculus ',
            createdBy: 'Dr. John Doe',
            assessmentCycle: 'Classroom Assessment',
            weightage: '10'
        },
        {
            id: 2,
            department: 'ENGLISH LITERATURE',
            programme: 'B.Sc. - Statistics',
            subject: 'Integral Calculus ',
            createdBy: 'Krish',
            assessmentCycle: 'Classroom Assessment',
            weightage: '10'
        },
        {
            id: 3,
            department: 'HISTORY',
            programme: 'B.Sc  - Mathematics',
            subject: 'Integral Calculus ',
            createdBy: 'Nivetha',
            assessmentCycle: 'Classroom Assessment',
            weightage: '10'
        },
    ]

    const getGradeForm = {
        department: { value: '', valid: false, error: '', validators: [Validators.required()] },
        programme: { value: '', valid: false, error: '', validators: [Validators.required()] },
        subject: { value: '', valid: false, error: '', validators: [Validators.required()] },
        assessmentCycle: { value: '', valid: false, error: '', validators: [Validators.required()] },
        weightage: { value: '', valid: false, error: '', validators: [Validators.required()] },
        condition: { value: '', valid: false, error: '', validators: [Validators.required()] },
        rule: { value: '', valid: false, error: '', validators: [Validators.required()] },
        value: { value: '', valid: false, error: '', validators: [Validators.required()] },
        grade: { value: '', valid: false, error: '', validators: [Validators.required()] },
    };

    const [locationListData, setLocationList] = useState([]);
    const [gradeForm, setGradeForm] = useState(getGradeForm);
    const [formValid, setFormValid] = useState(false);
    const [gradeModel, setgradeModel] = useState(false);
    const [departmentDetailData, setDepartmentDetailData] = useState({});
    const [message, setMessage] = useState({ type: '', message: '' });
    const [search, setSearch] = useState("");
    const [departmentListData, setDepartmentListData] = useState('');
    const [porgramlistdata, setProgramList] = useState([]);
    const [assessmentCycle,setAssessmentCycle] = useState([]);



    const editAction = (id) => {

    }

    const [config, setConfig] = useState({
        name: 'department',
        url: '',
        columns: [
            { name: 'NO. ', property: 'id', sort: false, width: '50px' },
            { name: 'Department', property: 'department', sort: false, width: '200px' },
            { name: 'Programme', property: 'programme', sort: false, width: '200px' },
            { name: 'Subject', property: 'subject', sort: false, width: '200px' },
            { name: 'Created By', property: 'createdBy', sort: false, width: '200px' },
            { name: 'Assessment Cycle', property: 'assessmentCycle', sort: false, width: '200px' },
            { name: 'Weightage', property: 'weightage', sort: false, width: '150px' },
            {
                name: '', property: '', columnType: '', width: '150px',
                actions: {
                    header: "",
                    row: [
                        {
                            type: 'view',
                            action: editAction
                        },
                        {
                            type: 'edit',
                            action: editAction
                        },
                        {
                            type: 'delete',
                            action: editAction
                        }
                    ]
                }
            },
        ],
        field: ["id", "phonenumber", "adminname", "email", "mobile", "locationtitle", "title", "locationid", "programs"],
        filter: [],
        sort: [{ "field": "id", "direction": "asc" }],
        pagination: true,
    });

    const opengradeModel = (data) => {
        setgradeModel(true);
        getGradeData();
    }

    const closeGradeModal = () => {
        setgradeModel(false);
        setDepartmentDetailData({});
        setLocationList([]);
    };
    const getGradeData = ()=> {
        Promise.all([getDepartmentList(), programListData(), getAssessmentCycle()]).then(responses => {
            let departmentData = responses[0];
            let programData = responses[1];
            let assessmentCycleData = responses[2].map((elem, i )=> {return {id : i, value: elem ,option: elem }} );
            setAssessmentCycle(assessmentCycleData)
            setDepartmentListData(
                departmentData.map(elem => {
                    return { value: elem.id, option: elem.title }
                }));
       
          })


    }

    const getAssessmentCycle = () => {
        return new Promise((resolve, reject) => {
            getApi(assessmentCycleList).then(response => {
                resolve(response.data.data);
            }).catch((error) => {
                reject(error);
            });
        })
    }

    const programListData = (id) => {
        let payload = {
          "filter": []
        }
        postApi(programmeList, payload).then((res) => {
          let resdata = res.data.data.map((elem) => {
            return { value: elem.id, option: elem.programmename }
          })
          setProgramList(resdata)
        })
      }

      const getDepartmentList = () => {
        // TODO check do we need to list only user department.
        let payload = {
            field: ["id", "phonenumber", "adminname", "locationtitle", "locationid", "title"],
        };
        return new Promise((resolve, reject) => {
            postApi(departmentList, payload).then(response => {
                resolve(response.data.data);
            }).catch((error) => {
                reject(error);
            });
        })
    };



    useEffect(() => {
        setFormValid(Validators.validateForm(gradeForm));
    }, [gradeForm]);

    const inputChange = (type, event) => {
      

        setGradeForm(prevState => {
            return {
                ...prevState,
                [type]: Validators.validateFormControl(prevState[type], event.target.value)
            }
        })
    };


    const addGradeRule = (isUpdate, addAnotherDepartment = false, loadProgrammes = false) => {
        let data = {
            "title": gradeForm.title.value,
            "locationid": gradeForm.locationid.value,
            "email": gradeForm.email.value,
            "adminname": gradeForm.adminname.value,
            "phonenumber": gradeForm.phonenumber.value,
        };

        if (isUpdate) {
            data["id"] = departmentDetailData.id
            putApi(departmentUpdate, { data }).then((response) => {
                setMessage({ type: 'success', message: "Grade Rule Updated Successfully" });

                dataTable.current?.searchData([]);

                setTimeout(() => {
                    closeGradeModal();
                    setMessage({ type: '', message: '' });
                }, 2000);

            }).catch((error) => {
                setMessage({ type: 'error', message: error.message });
                setTimeout(() => {
                    setMessage({ type: '', message: '' });
                }, 2000);
            })
        } else {
            postApi(departmentAdd, { data }).then((response) => {
                setMessage({ type: 'success', message: "Grade Rule Added Successfully" });

                dataTable.current?.searchData([]);

                if (addAnotherDepartment) {
                    setGradeForm(getGradeForm());
                }

                setTimeout(() => {

                    if (!addAnotherDepartment) {
                        closeGradeModal();
                    }

                    setMessage({ type: '', message: '' });

                

                }, 2000);

            }).catch((error) => {
                setMessage({ type: 'error', message: error.message });
                setTimeout(() => {
                    setMessage({ type: '', message: '' });
                }, 2000);
            })
        }
    }

    return (
        <div className="w-100">
            <div className="departments w-100">
                <text style={{ fontWeight: 'bold' }} className='m-3  text-primary text-2l'>{`Assessment Grading`}</text>
                <div className="d-flex w-100 department-section p-3 justify-content-between">


                    <div className="w-100 d-flex gap-2 rightcont">
                        <div className="w-50"></div>

                        <InputGroup className="">
                            <InputGroupText className="search" >
                                <i class="fa fa-search ml-3" ></i>
                            </InputGroupText>

                            <Form.Control className={`search`} type={'text'} style={{ borderRadius: '0px 5px 5px 0px', borderLeft: 'none' }} name={"search"} placeholder={"search by department / Created By / Programme / Subject / Assessment Cycle"}
                                onChange={(event) => {
                                    setSearch(event.target.value);

                                    // TODO check if already had a filter
                                    if (event.target.value.length == 0) {
                                        dataTable.current?.searchData([]);
                                    }
                                }}
                                onKeyPress={(event) => {
                                    if (event?.key === "Enter" && search)
                                        dataTable.current?.searchData([
                                            { field: 'title', value: search, op: 'LIKE', 'join': 'AND' }
                                        ])
                                }} />
                        </InputGroup>
                        <button type="button" style={{ borderRadius: '5px', marginLeft: '10px', width: '300px' }} onClick={() => { opengradeModel(); }} className="btn btn-primary" >Create Rule</button>
                    </div>

                </div>
                <div className="d-flex justify-content-between align-items-center px-4">
                    <text className='screen-sub-head'>Active Grading Rules</text>
                    <text className="m-0 text-">Total 150 rules</text>
                </div>


            </div>

            <div style={{ padding: '15px' }}>
                <Datatable ref={dataTable} config={config} gradeDataList={gradData} />
            </div>

            <Modal className="departments" show={gradeModel} onHide={closeGradeModal} size="lg" centered backdrop="static">
                <Modal.Header closeButton>
                    <Modal.Title className="text-primary" style={{ fontWeight: 'bold' }}>{departmentDetailData.id ? "Update Grading Rule" : 'Add Grading Rule'}</Modal.Title>
                </Modal.Header>
                <Modal.Body>

                    <div className="d-flex flex-column w-100 gap-3">

                        <div className="d-flex gap-3">
                            <SelectInput
                                type={'text'}
                                name={'department'}
                                label={'Department'}
                                placeholder={'Department'}
                                isMandatory={true}
                                options={departmentListData}
                                value={gradeForm.department.value}
                                error={gradeForm.department.error}
                                onChange={(event) => inputChange("department", event)}
                            />

                            <SelectInput
                                type={'text'}
                                name={'programme'}
                                label={'Programme'}
                                placeholder={'Programme'}
                                options={porgramlistdata}
                                isMandatory={true}
                                value={gradeForm.programme.value}
                                error={gradeForm.programme.error}
                                onChange={(event) => inputChange("programme", event)}
                            />
                        </div>

                        <div className="d-flex gap-3">


                            <TextInput
                                type={'text'}
                                name={'subject'}
                                label={'Subject'}
                                placeholder={'Subject'}
                                isMandatory={true}
                                value={gradeForm.subject.value}
                                error={gradeForm.subject.error}
                                onChange={(event) => inputChange("subject", event)}
                            />

                            <SelectInput
                                name={'assessmentCycle'}
                                label={'Assessment Cycle'}
                                placeholder={'Assessment Cycle'}
                                isMandatory={true}
                                value={gradeForm.assessmentCycle.value}
                                options={assessmentCycle}
                                error={gradeForm.assessmentCycle.error}
                                onChange={(event) => inputChange('assessmentCycle', event)}
                            />
                        </div>

                        <div className="d-flex gap-3">
                            <TextInput
                                type={'text'}
                                name={'weightage'}
                                label={'Weightage'}
                                placeholder={'Weightage'}
                                isMandatory={true}
                                value={gradeForm.weightage.value}
                                error={gradeForm.weightage.error}
                                onChange={(event) => inputChange("weightage", event)}
                            />

                            <SelectInput
                                type={'text'}
                                name={'condition'}
                                label={'Condition'}
                                placeholder={'Condition'}
                                isMandatory={true}
                                options={conditions}
                                value={gradeForm.condition.value}
                                error={gradeForm.condition.error}
                                onChange={(event) => inputChange("condition", event)}
                            />
                        </div>

                        <div className="d-flex gap-3">
                            <SelectInput
                                type={'text'}
                                name={'rule'}
                                label={'Rule'}
                                placeholder={'Rule'}
                                isMandatory={true}
                                options={rules}
                                value={gradeForm.rule.value}
                                error={gradeForm.rule.error}
                                onChange={(event) => inputChange("rule", event)}
                            />

                            <TextInput
                                type={'text'}
                                name={'value'}
                                label={'Value'}
                                placeholder={'Value'}
                                isMandatory={true}
                                value={gradeForm.value.value}
                                error={gradeForm.value.error}
                                onChange={(event) => inputChange("value", event)}
                            />
                        </div>

                        <div className="d-flex gap-3">
                            <TextInput
                                type={'text'}
                                name={'grade'}
                                label={'Grade'}
                                placeholder={'Grade'}
                                isMandatory={true}
                                value={gradeForm.grade.value}
                                error={gradeForm.grade.error}
                                onChange={(event) => inputChange("grade", event)}
                            />
                        </div>

                    </div>

                    <div style={{ padding: '0px 20px 0px 20px' }}>
                        <div className="mt-5" style={{ textAlign: 'center', width: '100%' }}>
                            <p style={{ color: message.type === 'success' ? 'green' : '#A50050' }}>{message.message}</p>
                        </div>
                    </div>

                </Modal.Body>
                <Modal.Footer className="d-flex" style={{ justifyContent: 'center' }}>
                    {
                        departmentDetailData.id ?
                            <Button disabled={!formValid} onClick={() => addGradeRule(true)}>Update Grading Rule</Button> :
                            <>
                                <Button onClick={() => closeGradeModal()}>Cancel</Button>
                                <Button disabled={!formValid} onClick={() => addGradeRule(false, true)}>Create</Button>
                            </>
                    }
                </Modal.Footer>
            </Modal>

        </div>
    );
}

export default AssessmentGrade;
